import {connect} from 'react-redux';
import ContactLogin from './ContactLogin';
import {sendContactMail} from '../../../../common/actions/sendContactMail'
import {showGlobalErrorMessage} from "common/actions/globalErrorMessage/showGlobalErrorMessage";

export default connect(
  null,
  {sendContactMail, showGlobalErrorMessage}
)(ContactLogin);
